import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { name: '电视剧', path: '/category/dianshiju' },
    { name: '电影', path: '/category/dianying' },
    { name: '综艺', path: '/category/zongyi' },
    { name: '动漫', path: '/category/dongman' },
    { name: '纪录片', path: '/category/jilupian' },
    { name: '短剧', path: '/category/zhuipian' },
  ],
  platforms: [
    { name: '红桃视频', path: '/category/dianshiju' },
    { name: '樱花视频', path: '/category/dianying' },
    { name: '糖豆视频', path: '/category/zongyi' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '用户协议', path: '/' },
    { name: '隐私政策', path: '/' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-900">
                芭乐视频
              </span>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              聚合红桃视频、樱花视频、糖豆视频等特色视频平台内容，提供高清免费在线观看，无需缓冲，各类最新电视剧电影资源一应俱全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 cursor-pointer transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 cursor-pointer transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 cursor-pointer transition-all duration-200" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 text-sm hover:text-primary-500 cursor-pointer transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">合作平台</h4>
            <ul className="space-y-2.5">
              {footerLinks.platforms.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 text-sm hover:text-primary-500 cursor-pointer transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-600 text-sm hover:text-primary-500 cursor-pointer transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <p className="text-foreground-500 text-xs">客服邮箱</p>
              <p className="text-foreground-700 text-sm font-medium">support@balevideo.com</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; 2020-2026 芭乐视频 balevideo.com 版权所有
          </p>
          <p className="text-foreground-400 text-xs">
            本站内容来源于合作平台，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}